import axios from "axios";
import Vue from "vue";

export const state = {
  modes: [],
  statement: [],
  save_status: false,
};
export const getters = {
  Modes: (state) => state.modes,
  Statement: (state) => state.statement.data,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_MODES(state, newValue) {
    state.modes = newValue;
  },
  SET_STATEMENT(state, newValue) {
    state.statement = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addMode({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("modes", payload)
      .then(() => {
        dispatch("fetchModes");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Added Payment Mode",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Adding Payment Mode",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit Mode
  editMode({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`modes/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchModes");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Edited Payment Mode",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Editing Payment Mode",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Mode
  deleteMode({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`modes/${payload.id}`)
      .then(() => {
        dispatch("fetchModes");
        const message = {
          type: "primary",
          title: "<b>Success Notifications</b>",
          message: "Successfully, Deleted Payment Mode",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Deleting Payment Mode",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchModes({ commit }) {
    axios.get(`modes`).then((pos) => {
      commit("SET_MODES", pos.data);
    });
  },
  fetchStatement({ commit }, id) {
    axios.get(`modes/${id}`).then((sta) => {
      commit("SET_STATEMENT", sta.data);
    });
  },
};
